/**
 * PixelTracker
 * Construtor takes tracking pixel URL parameters settings
 */
class PixelTracker {
    constructor(props) {
        this.settings = props.context;
        this.container = props.container;

        this.previousPlaythrough = 0;
        this.playthroughLevels = this._getPlaythroughLevels();
        this.startOffset = this._getStartOffset();
        this.playReported = false;
    }

    _calculatePlaythrough = (time, duration) => Math.round((time / duration) * 100);

    _getStartOffset = () => {
        const values = Object.keys(this.settings).filter((n) => {
            return n.endsWith('s');
        });
        return values[0];
    };

    _getPlaythroughLevels = () => {
        return Object.keys(this.settings).filter((n) => {
            const intNum = parseInt(n);
            return intNum && intNum >= 0 && intNum <= 100;
        });
    };

    _getNextLevelToReport = () => {
        const prevLevel = this.playthroughLevels.indexOf(this.previousPlaythrough);
        return this.playthroughLevels[prevLevel + 1];
    };

    _parseUrl = (url) => {
        if (!url || typeof url !== 'string') {
            return console.error('Url setting for tracking pixel is invalid');
        }

        const now = new Date().getTime();
        return url.replace('[timestamp]', now);
    };

    _shouldFetchNewPixel = (playthrough, nextPlaythroughToReport) => {
        return playthrough >= nextPlaythroughToReport;
    };

    _setTrackingPixelImage = (url, playthrough) => {
        // Sets 3rd party tracking pixel on site
        const element = new DOMParser().parseFromString(
            `<img src="${url}" border="0" height="1" width="1" style="float:left;" alt="Advertisement">`,
            'text/html',
        );
        const imgElement = element.body.firstChild;
        this.container.appendChild(imgElement);
        console.log(`Added pixel image tracking: URL ${url}, Playthrough: ${playthrough}`);
        this._trackSuccessRate(imgElement, playthrough);
    };

    // Our cross check tracking
    _trackSuccessRate = (element, playthrough = 0) => {
        // Count ad blocker for each playthrough that was supposed to be reported
        setTimeout(() => {
            if (element && element.offsetWidth === 0 && element.offsetHeight === 0) {
                gtag('event', 'pixel_tracking_blocked', {
                    event_category: 'Pixel tracking',
                    event_label: context.videoId,
                });
            }
        }, 1000);
    };

    trackInitialPlay = () => {
        if ('play' in this.settings && !this.playReported) {
            try {
                const url = this._parseUrl(this.settings.play);
                this._setTrackingPixelImage(url);
                this.playReported = true;
            } catch (error) {
                console.error(error);
            }
        }
    };

    _reportCustomStartOffset = (time) => {
        // Report custom play offset
        if (!this.playReported && this.startOffset) {
            const timeOffset = Number.parseInt(this.startOffset.split('s')[0]);
            if (Math.floor(time) >= timeOffset) {
                const url = this._parseUrl(this.settings[this.startOffset]);
                this._setTrackingPixelImage(url, this.startOffset);
                this.playReported = true;
            }
        }
    };

    /**
     * Currently, we are fetching all tracking pixels provided in settings file
     * Example: If user skips from 30% playthrough to 80%, we'll fetch both pixel for 50% playthrough and 75% playthrough
     *
     * @memberof PixelTracker
     */
    update = (time, duration) => {
        try {
            const playthrough = this._calculatePlaythrough(time, duration);
            const nextPlaythroughToReport = this._getNextLevelToReport();

            const shouldFetch = this._shouldFetchNewPixel(playthrough, nextPlaythroughToReport);
            if (shouldFetch) {
                const url = this._parseUrl(this.settings[nextPlaythroughToReport]);
                this.previousPlaythrough = nextPlaythroughToReport;
                this._setTrackingPixelImage(url, nextPlaythroughToReport);
            }
            this._reportCustomStartOffset(time);
        } catch (error) {
            console.log(error);
        }
    };
}

export default PixelTracker;
